import { render, staticRenderFns } from "./UpdateDados.vue?vue&type=template&id=30ecb5bf&"
import script from "./UpdateDados.vue?vue&type=script&lang=js&"
export * from "./UpdateDados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports